import Rollbar from 'rollbar'
import { rollbarConfig } from './constants'

export const rollbar = new Rollbar(rollbarConfig)

export const rollbarServerInstance = new Rollbar({
  ...rollbarConfig,
  accessToken: process.env.ROLLBAR_SERVER_ACCESS_TOKEN,
})
